import React from 'react';
import { TopLevelContainer } from '@xo-union/tk-component-grid';
import SubNavLinkItem from './sub-nav-item';
import styles from './styles.css';

export default function SubNav (props) {
  const pillItems = [
    {
      href: "/fashion/wedding-hair-pins-combs-clips",
      label: "Hair Pins, Clips & Combs"
    },
    {
      href: "/fashion/wedding-shoes",
      label: "Shoes"
    }
  ]

  const { subNavItems, activeItem } = props;

  return (
    <nav className={styles['nav-container']}>
      <TopLevelContainer>
        <div id="header-sub-nav" className={styles.container}>
          <div className={styles['left-content']}>
            <ul className={styles['nav-list']}>
              {
                subNavItems.map((item, index) => (
                  <SubNavLinkItem
                    key={item.href}
                    item={item}
                    index={index}
                    isActive={activeItem == item.href}
                  />
                ))
              }
            </ul>
          </div>
              {/* Pill items should be rendered here */}
        </div>
      </TopLevelContainer>
    </nav>
  );
}
